import { translate } from '../../common/translation/translate';

export const getPollenDescriptors = (pollenIndex) => {
    if (!pollenIndex) {
        return {
            color: '#AFAFAF',
            description: translate('notAvailable')
        };
    }
    if (pollenIndex < 2.5) {
        return {
            color: '#1DCF6D',
            description: translate('low')
        };
    } else if (pollenIndex < 4.9) {
        return {
            color: '#00BC57',
            description: translate('lowMedium')
        };
    } else if (pollenIndex < 7.3) {
        return {
            color: '#FADD49',
            description: translate('medium')
        };
    } else if (pollenIndex < 9.7) {
        return {
            color: '#F59D00',
            description: translate('mediumHigh')
        };
    } else {
        return {
            color: '#ED5B43',
            description: translate('high')
        };
    }
};
